/* eslint-disable global-require */
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import './api/axios';

import store from './store';
import theme from './theme';

const loadModule = async ({ name }) => {
  let Module;
  switch (name) {
    case 'Onboarding':
      Module = await import('./onboarding/index');
      break;
    case 'QuestionDetailPage':
      Module = await import('./scripts/question-detail-page');
      break;
    case 'LanguageFeed':
      Module = await import('./translation/language_feeds');
      break;
    case 'QuestionFeedback':
      Module = await import('./scripts/question-feedback');
      break;
    case 'CustomFeedIndex':
      Module = await import('./scripts/custom-feed-index');
      break;
    default:
      break;
  }
  return Module;
};

const loadComponent = ({ name, props = {}, mountPoint }) => {
  let Component;

  if (!name || !mountPoint) return;

  switch (name) {
    case 'NavBar':
      Component = React.lazy(() => import('./components/NavBar'));
      break;
    case 'ToDos':
      Component = React.lazy(() => import('./pages/careerpaths'));
      break;
    case 'LanguageSettings':
      Component = React.lazy(() => import('./pages/settings/LanguageSettings'));
      break;
    case 'AskPage':
      Component = React.lazy(() => import('./pages/questions/AskPage'));
      break;
    case 'AnswerUseful':
      Component = React.lazy(() => import('./pages/questions/components/AnswerUseful'));
      break;
    case 'NotificationBar':
      Component = React.lazy(() => import('./components/v3/NotificationBar'));
      break;
    case 'Educator':
      Component = React.lazy(() => import('./pages/Educator'));
      break;
    case 'Student':
      Component = React.lazy(() => import('./pages/Student'));
      break;
    case 'Professional':
      Component = React.lazy(() => import('./pages/Professional'));
      break;
    case 'EndorseAnswer':
      Component = React.lazy(() => import('./pages/questions/components/EndorseAnswer'));
      break;
    case 'TopicsSettings':
      Component = React.lazy(() => import('./pages/settings/TopicsSettings'));
      break;
    default:
      break;
  }

  ReactDOM.render(
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Suspense fallback={<></>}>
          <Component {...props} />
        </Suspense>
      </ThemeProvider>
    </Provider>, document.getElementById(mountPoint),
  );
};

window.loadModule = loadModule;
window.loadComponent = loadComponent;

window.addEventListener('load', () => {
  const event = new Event('WEBPACK_LOADED');
  document.dispatchEvent(event);
});
